
class ZenfeliNavigation extends HTMLElement{
 connectedCallback(){
  this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;
  const menu=this.querySelector('#shopMenu'),trigger=this.querySelector('#shopTrigger');
  const toggle=on=>{if(menu)menu.classList.toggle('open',on);trigger?.setAttribute('aria-expanded',String(on))};
  trigger?.addEventListener('click',()=>toggle(true),{signal});
  for(const el of [trigger,menu]){el?.addEventListener('mouseenter',()=>{clearTimeout(this.closeTimer);toggle(true)},{signal});el?.addEventListener('mouseleave',()=>{this.closeTimer=setTimeout(()=>toggle(false),180)},{signal})}
  document.addEventListener('click',e=>{if(!menu?.contains(e.target)&&!trigger?.contains(e.target))toggle(false)},{signal});
  for(const [id,target]of [['searchOpen','searchLayer'],['mobileOpen','mobileLayer']])this.querySelector('#'+id)?.addEventListener('click',()=>this.querySelector('#'+target)?.showModal(),{signal});
  for(const dialog of this.querySelectorAll('dialog')){
   dialog.addEventListener('click',e=>{if(e.target===dialog||e.target.closest('[data-close-dialog]'))dialog.close()},{signal});
   dialog.addEventListener('close',()=>document.body.classList.remove('no-scroll'),{signal});
   dialog.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>dialog.close(),{signal}));
  }
  document.addEventListener('keydown',e=>{if(e.key==='Escape')toggle(false)},{signal});
 }
 disconnectedCallback(){this.controller?.abort();clearTimeout(this.closeTimer)}
}
if(!customElements.get('zf-navigation'))customElements.define('zf-navigation',ZenfeliNavigation);
class ZenfeliGallery extends HTMLElement{
 connectedCallback(){this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;for(const card of this.querySelectorAll('.collection-card')){
  let timer;const stop=()=>{clearInterval(timer);card.classList.remove('show-alternate')};
  const start=()=>{stop();if(matchMedia('(prefers-reduced-motion:reduce)').matches||!card.querySelector('.secondary'))return;timer=setInterval(()=>card.classList.toggle('show-alternate'),2000)};
  card.addEventListener('mouseenter',start,{signal});card.addEventListener('mouseleave',stop,{signal});card.addEventListener('focusin',start,{signal});card.addEventListener('focusout',stop,{signal});document.addEventListener('visibilitychange',stop,{signal});this.stops??=[];this.stops.push(stop);
 }}
 disconnectedCallback(){this.controller?.abort();this.stops?.forEach(fn=>fn());this.stops=[]}
}
if(!customElements.get('zf-gallery'))customElements.define('zf-gallery',ZenfeliGallery);
window.zfIntroComplete=false;
window.zfIntroReady=new Promise(resolve=>{
 const loader=document.getElementById('zfPreloader');
 const finish=()=>{loader?.remove();window.zfIntroComplete=true;resolve()};
 if(!loader||window.Shopify?.designMode||matchMedia('(prefers-reduced-motion:reduce)').matches){finish();return}
 let played=false;try{played=sessionStorage.getItem('zenfeli-intro')==='1';sessionStorage.setItem('zenfeli-intro','1')}catch{}
 if(played){finish();return}
 loader.hidden=false;
 const reduced=matchMedia('(prefers-reduced-motion:reduce)');
 const end=()=>{clearTimeout(fade);clearTimeout(done);reduced.removeEventListener('change',end);finish()};
 const fade=setTimeout(()=>loader.classList.add('done'),1850),done=setTimeout(end,2850);
 reduced.addEventListener('change',end,{once:true});
});
